import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RodsReelsPage = lazy(() => import('../pages/rods-reels/page'));
const LuresBaitsPage = lazy(() => import('../pages/lures-baits/page'));
const IceFishingPage = lazy(() => import('../pages/ice-fishing/page'));
const PiscifunIcxFrostReviewPage = lazy(() => import('../pages/ice-fishing/piscifun-icx-frost-ice-fishing-reel/page'));
const ThirteenFishingFreefallReviewPage = lazy(() => import('../pages/ice-fishing/13-fishing-freefall-ghost-inline-ice-fishing-reels/page'));
const StCroixIceRodReviewPage = lazy(() => import('../pages/ice-fishing/st-croix-rods-custom-ice-fishing-rod/page'));
const ShimanoStraticReviewPage = lazy(() => import('../pages/rods-reels/shimano-stradic-fl-spinning-reel/page'));
const StCroixBassXReviewPage = lazy(() => import('../pages/rods-reels/st-croix-bass-x-casting-rod/page'));
const RapalaXRapReviewPage = lazy(() => import('../pages/lures-baits/rapala-x-rap-jerkbait-xr10/page'));
const ZoomTrickWormReviewPage = lazy(() => import('../pages/lures-baits/zoom-trick-worm-20-pack/page'));
const LuckEStrikeSTXJerkbaitReviewPage = lazy(() => import('../pages/lures-baits/luck-e-strike-stx-jerkbait/page'));
const BooyahFlashPointJerkbaitReviewPage = lazy(() => import('../pages/lures-baits/booyah-flash-point-jerkbait/page'));
const SFIceFishingTipUpReviewPage = lazy(() => import('../pages/ice-fishing/sf-ice-fishing-tip-up/page'));
const ThirteenFishingTickleStickReviewPage = lazy(() => import('../pages/ice-fishing/13-fishing-tickle-stick-ice-rod/page'));
const PopUpIceFishingTentReviewPage = lazy(() => import('../pages/ice-fishing/pop-up-ice-fishing-tent/page'));
const EskimoHC40AugerReviewPage = lazy(() => import('../pages/ice-fishing/eskimo-hc40-power-ice-auger-8-inch/page'));
const FrabillTipUpReviewPage = lazy(() => import('../pages/ice-fishing/frabill-ice-fishing-tip-up/page'));
const EskimoPortableShelterReviewPage = lazy(() => import('../pages/ice-fishing/eskimo-portable-shelter/page'));
const QuantumStriveReviewPage = lazy(() => import('../pages/rods-reels/quantum-strive-spinning-fishing-reel/page'));
const PennBattleIVReviewPage = lazy(() => import('../pages/rods-reels/penn-battle-iv-spinning-fishing-reel/page'));
const ShimanoC3000XGReviewPage = lazy(() => import('../pages/rods-reels/shimano-c3000xg-spinning-reel/page'));
const UglyStikEliteReviewPage = lazy(() => import('../pages/rods-reels/ugly-stik-elite-spinning-rod/page'));
const UglyStikGX2ReviewPage = lazy(() => import('../pages/rods-reels/ugly-stik-gx2-spinning-rod/page'));
const StCroixTriumphSpinningRodPage = lazy(() => import('../pages/rods-reels/st-croix-rods-triumph-spinning-rod/page'));
const PennSquadronIIIReviewPage = lazy(() => import('../pages/rods-reels/penn-squadron-iii-surf-spinning-rod/page'));
const StrikeKingKVDJerkbaitReviewPage = lazy(() => import('../pages/lures-baits/strike-king-kvd-jerkbait/page'));
const YamamotoSenkoReviewPage = lazy(() => import('../pages/lures-baits/yamamoto-5-senko-green-pumpkin/page'));
const StrikeKingKVDEliteSquarebillCrankbaitReviewPage = lazy(() => import('../pages/lures-baits/strike-king-kvd-elite-squarebill-crankbait/page'));
const StrikeKingProModel10XDCrankbaitReviewPage = lazy(() => import('../pages/lures-baits/strike-king-pro-model-10xd-crankbait/page'));
const RapalaRippinRapReviewPage = lazy(() => import('../pages/lures-baits/rapala-rippin-rap/page'));
const WarEagleNickelFrameFinesseSpinnerbaitReviewPage = lazy(() => import('../pages/lures-baits/war-eagle-nickel-frame-finesse-spinnerbait/page'));
const BooyahMoontalkerSpinnerbaitReviewPage = lazy(() => import('../pages/lures-baits/booyah-moontalker-spinnerbait/page'));
const BerkleyChoppoTopwaterReviewPage = lazy(() => import('../pages/lures-baits/berkley-choppo-topwater/page'));
const SmithwickDevilsHorsePropellerTopwaterReviewPage = lazy(() => import('../pages/lures-baits/smithwick-devils-horse-propeller-topwater/page'));
const StrikeKingHackAttackHeavyCoverJigReviewPage = lazy(() => import('../pages/lures-baits/strike-king-hack-attack-heavy-cover-jig/page'));
const AbuGarciaVengeanceReviewPage = lazy(() => import('../pages/rods-reels/abu-garcia-vengeance-casting-rod/page'));
const AbuGarciaVeritasReviewPage = lazy(() => import('../pages/rods-reels/abu-garcia-veritas-casting-rod/page'));
const UglyStikCarbonCastingRodReviewPage = lazy(() => import('../pages/rods-reels/ugly-stik-carbon-casting-rod/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));
const AffiliateDisclosurePage = lazy(() => import('../pages/affiliate-disclosure/page'));
const StrikeMasterMoraHandAugerPage = lazy(() => import('../pages/ice-fishing/strike-master-mora-2-piece-hand-ice-auger/page'));
const FlyFishingPage = lazy(() => import('../pages/fly-fishing/page'));
const MoonshineRodReviewPage = lazy(() => import('../pages/fly-fishing/moonshine-rod-co-fly-fishing-rod/page'));
const LamsonLiquidReelReviewPage = lazy(() => import('../pages/fly-fishing/lamson-liquid-s-series-hd-fly-fishing-reel/page'));
const PiscifunSwordFlyLineReviewPage = lazy(() => import('../pages/fly-fishing/piscifun-sword-fly-fishing-line/page'));
const RoxStarTrophyTroutReviewPage = lazy(() => import('../pages/fly-fishing/roxstar-trophy-trout-fly-assortment/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PiscifunSwordReviewPage = lazy(() => import('../pages/fly-fishing/piscifun-sword-fly-fishing-line/page'));
const FroggToggsHellbenderReviewPage = lazy(() => import('../pages/fly-fishing/frogg-toggs-hellbender-breathable-waterproof-chest-wader/page'));
const RedingtonStarterKitReviewPage = lazy(() => import('../pages/fly-fishing/redington-fly-fishing-rod-reel-complete-starter-kit/page'));
const OrvisEncounterReviewPage = lazy(() => import('../pages/fly-fishing/orvis-encounter-fly-fishing-rod-reel-combo/page'));
const QualyQualyChestPackReviewPage = lazy(() => import('../pages/fly-fishing/qualyqualy-fly-fishing-chest-pack/page'));
const VenturesFlyCoPage = lazy(() => import('../pages/fly-fishing/ventures-fly-co-122-premium-hand-tied-fly-fishing-flies-assortment/page'));
const SFFlyFishingLinePage = lazy(() => import('../pages/fly-fishing/sf-fly-fishing-line/page'));
import PiscifunSwordFlyFishingReelPage from '../pages/fly-fishing/piscifun-sword-fly-fishing-reel/page';
const MaxcatchUltraliteXPage = lazy(() => import('../pages/fly-fishing/maxcatch-ultralite-x-fly-fishing-rod/page'));
const TackleAccessoriesPage = lazy(() => import('../pages/tackle-accessories/page'));
const PlanoGuideSeriesReviewPage = lazy(() => import('../pages/tackle-accessories/plano-guide-series-stowaway-4-rack-tackle-box/page'));
const KastKingSpeedDemonProFilletKnifePage = lazy(() => import('../pages/tackle-accessories/kastking-speed-demon-pro-fillet-knife/page'));
const PiscifunFishingLineSpoolerReviewPage = lazy(() => import('../pages/tackle-accessories/piscifun-fishing-line-spooler/page'));
const GamakatsuRedOctopusHookPage = lazy(() => import('../pages/tackle-accessories/gamakatsu-red-octopus-hook-100-pack/page'));
import KastKingKarryAllBackpackPage from '../pages/tackle-accessories/kastking-karryall-fishing-tackle-backpack-with-rod-holder/page';
const ReactionTackleCarolinaRigsPage = lazy(() => import('../pages/tackle-accessories/reaction-tackle-carolina-rigs-for-bass-fishing-6-pack/page'));
const KastKingHyperSealTackleBoxPage = lazy(() => import('../pages/tackle-accessories/kastking-hyperseal-waterproof-tackle-box-2-pack/page'));
import KanamaLuminousShrimHooksReviewPage from '../pages/tackle-accessories/kanama-luminous-live-shrimp-hooks/page';
const HoshanhoFilletKnifePage = lazy(() => import('../pages/tackle-accessories/hoshanho-7-inch-fillet-knife/page'));
const BaitiumFishingTackleBagPage = lazy(() => import('../pages/tackle-accessories/baitium-fishing-tackle-bag-with-rod-holders/page'));
const KastKingBaitSpaceLineManagementBagPage = lazy(() => import('../pages/tackle-accessories/kastking-baitspace-line-management-bag/page'));
const DeepDropSnapperRigPage = lazy(() => import('../pages/tackle-accessories/deep-drop-snapper-rig/page'));
const FluorocarbonLeadersPage = lazy(() => import('../pages/tackle-accessories/20-inch-50lb-100-fluorocarbon-fishing-leaders/page'));
const TackleAccessoriesKastKingBaitSpaceLineManagementBag = lazy(() => import('../pages/tackle-accessories/kastking-baitspace-line-management-bag/page'));
const TackleAccessoriesDeepDropSnapperRig = lazy(() => import('../pages/tackle-accessories/deep-drop-snapper-rig/page'));
const TackleAccessoriesDrfishCarolinaRigsPage = lazy(() => import('../pages/tackle-accessories/drfish-10-carolina-ready-rigs-15-pack/page'));
const TackleAccessories16InchFluorocarbonLeaderLinePage = lazy(() => import('../pages/tackle-accessories/16-inch-20lbs-fluorocarbon-fishing-leader-line-with-swivels-snap-kits/page'));
const MeppsBronzeSlammerPage = lazy(() => import('../pages/lures-baits/mepps-bs5t-bk-fcr-bronze-slammer-dressed-treble-1-2-oz-firecraw/page'));
const BerkleyFlickerShadPage = lazy(() => import('../pages/lures-baits/berkley-flicker-shad-freshwater-crankbait/page'));
const BanditLuresJerkbaitReviewPage = lazy(() => import('../pages/lures-baits/bandit-lures-slender-minnow-jerkbait/page'));
const RodsReelsAbuGarciaVeritasPage = lazy(() => import('../pages/rods-reels/abu-garcia-veritas-casting-rod/page'));
const RodsReelsUglyStikCarbonPage = lazy(() => import('../pages/rods-reels/ugly-stik-carbon-casting-rod/page'));
const RodsReelsAbuGarciaVengeancePage = lazy(() => import('../pages/rods-reels/abu-garcia-vengeance-casting-rod/page'));
const RodsReelsUglyStikElitePage = lazy(() => import('../pages/rods-reels/ugly-stik-elite-spinning-rod/page'));
const RodsReelsStCroixTriumphPage = lazy(() => import('../pages/rods-reels/st-croix-rods-triumph-spinning-rod/page'));
const RodsReelsPennSquadronPage = lazy(() => import('../pages/rods-reels/penn-squadron-iii-surf-spinning-rod/page'));
const RodsReelsUglyStikGX2Page = lazy(() => import('../pages/rods-reels/ugly-stik-gx2-spinning-rod/page'));
const RodsReelsPennBattlePage = lazy(() => import('../pages/rods-reels/penn-battle-iv-spinning-fishing-reel/page'));
const RodsReelsShimanoC3000XGPage = lazy(() => import('../pages/rods-reels/shimano-c3000xg-spinning-reel/page'));
const RodsReelsShimanoStraticPage = lazy(() => import('../pages/rods-reels/shimano-stradic-fl-spinning-reel/page'));
const RodsReelsQuantumStrivePage = lazy(() => import('../pages/rods-reels/quantum-strive-spinning-fishing-reel/page'));
const RodsReelsKastKingMegatronPage = lazy(() => import('../pages/rods-reels/kastking-megatron-200-baitcasting-fishing-reel/page'));
const RodsReelsStCroixBassXPage = lazy(() => import('../pages/rods-reels/st-croix-bass-x-casting-rod/page'));
const PiscifunAlijoz300Page = lazy(() => import('../pages/rods-reels/piscifun-alijoz-300-baitcasting-reel/page'));
const ShimanoSLXBaitcastingReelPage = lazy(() => import('../pages/rods-reels/shimano-slx-baitcasting-reel/page'));
const KastKingKapstanElite300Page = lazy(() => import('../pages/rods-reels/kastking-kapstan-elite-300-baitcasting-reel/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/rods-reels',
    element: <RodsReelsPage />,
  },
  {
    path: '/lures-baits',
    element: <LuresBaitsPage />,
  },
  {
    path: '/ice-fishing',
    element: <IceFishingPage />,
  },
  {
    path: '/ice-fishing/piscifun-icx-frost-ice-fishing-reel',
    element: <PiscifunIcxFrostReviewPage />,
  },
  {
    path: '/ice-fishing/13-fishing-freefall-ghost-inline-ice-fishing-reels',
    element: <ThirteenFishingFreefallReviewPage />,
  },
  {
    path: '/ice-fishing/st-croix-rods-custom-ice-fishing-rod',
    element: <StCroixIceRodReviewPage />,
  },
  {
    path: '/ice-fishing/sf-ice-fishing-tip-up',
    element: <SFIceFishingTipUpReviewPage />,
  },
  {
    path: '/ice-fishing/13-fishing-tickle-stick-ice-rod',
    element: <ThirteenFishingTickleStickReviewPage />,
  },
  {
    path: '/rods-reels/shimano-stradic-fl-spinning-reel',
    element: <ShimanoStraticReviewPage />,
  },
  {
    path: '/rods-reels/st-croix-bass-x-casting-rod',
    element: <StCroixBassXReviewPage />,
  },
  {
    path: '/rods-reels/quantum-strive-spinning-fishing-reel',
    element: <QuantumStriveReviewPage />,
  },
  {
    path: '/rods-reels/kastking-megatron-200-baitcasting-fishing-reel',
    element: <RodsReelsKastKingMegatronPage />,
  },
  {
    path: '/rods-reels/piscifun-alijoz-300-baitcasting-reel',
    element: <PiscifunAlijoz300Page />,
  },
  {
    path: '/rods-reels/shimano-slx-baitcasting-reel',
    lazy: async () => {
      const Component = (await import('../pages/rods-reels/shimano-slx-baitcasting-reel/page')).default;
      return { element: <Component /> };
    }
  },
  {
    path: '/rods-reels/kastking-kapstan-elite-300-baitcasting-reel',
    element: <KastKingKapstanElite300Page />,
  },
  {
    path: '/rods-reels/penn-battle-iv-spinning-fishing-reel',
    element: <PennBattleIVReviewPage />,
  },
  {
    path: '/rods-reels/shimano-c3000xg-spinning-reel',
    element: <ShimanoC3000XGReviewPage />,
  },
  {
    path: '/rods-reels/ugly-stik-elite-spinning-rod',
    element: <UglyStikEliteReviewPage />,
  },
  {
    path: '/rods-reels/ugly-stik-gx2-spinning-rod',
    element: <UglyStikGX2ReviewPage />,
  },
  {
    path: '/rods-reels/st-croix-rods-triumph-spinning-rod',
    element: <StCroixTriumphSpinningRodPage />,
  },
  {
    path: '/rods-reels/penn-squadron-iii-surf-spinning-rod',
    element: <PennSquadronIIIReviewPage />,
  },
  {
    path: '/rods-reels/abu-garcia-vengeance-casting-rod',
    element: <AbuGarciaVengeanceReviewPage />,
  },
  {
    path: '/rods-reels/abu-garcia-veritas-casting-rod',
    element: <AbuGarciaVeritasReviewPage />,
  },
  {
    path: '/rods-reels/ugly-stik-carbon-casting-rod',
    element: <UglyStikCarbonCastingRodReviewPage />,
  },
  {
    path: '/lures-baits/rapala-x-rap-jerkbait-xr10',
    element: <RapalaXRapReviewPage />,
  },
  {
    path: '/lures-baits/zoom-trick-worm-20-pack',
    element: <ZoomTrickWormReviewPage />,
  },
  {
    path: '/lures-baits/luck-e-strike-stx-jerkbait',
    element: <LuckEStrikeSTXJerkbaitReviewPage />,
  },
  {
    path: '/lures-baits/strike-king-kvd-jerkbait',
    element: <StrikeKingKVDJerkbaitReviewPage />,
  },
  {
    path: '/lures-baits/booyah-flash-point-jerkbait',
    element: <BooyahFlashPointJerkbaitReviewPage />,
  },
  {
    path: '/lures-baits/yamamoto-5-senko-green-pumpkin',
    element: <YamamotoSenkoReviewPage />,
  },
  {
    path: '/lures-baits/strike-king-kvd-elite-squarebill-crankbait',
    element: <StrikeKingKVDEliteSquarebillCrankbaitReviewPage />,
  },
  {
    path: '/lures-baits/strike-king-pro-model-10xd-crankbait',
    element: <StrikeKingProModel10XDCrankbaitReviewPage />,
  },
  {
    path: '/lures-baits/rapala-rippin-rap',
    element: <RapalaRippinRapReviewPage />,
  },
  {
    path: '/lures-baits/war-eagle-nickel-frame-finesse-spinnerbait',
    element: <WarEagleNickelFrameFinesseSpinnerbaitReviewPage />,
  },
  {
    path: '/lures-baits/booyah-moontalker-spinnerbait',
    element: <BooyahMoontalkerSpinnerbaitReviewPage />,
  },
  {
    path: '/lures-baits/berkley-choppo-topwater',
    element: <BerkleyChoppoTopwaterReviewPage />,
  },
  {
    path: '/lures-baits/smithwick-devils-horse-propeller-topwater',
    element: <SmithwickDevilsHorsePropellerTopwaterReviewPage />,
  },
  {
    path: '/lures-baits/strike-king-hack-attack-heavy-cover-jig',
    element: <StrikeKingHackAttackHeavyCoverJigReviewPage />,
  },
  {
    path: '/lures-baits/mepps-bs5t-bk-fcr-bronze-slammer-dressed-treble-1-2-oz-firecraw',
    element: <MeppsBronzeSlammerPage />,
  },
  {
    path: '/ice-fishing/pop-up-ice-fishing-tent',
    element: <PopUpIceFishingTentReviewPage />,
  },
  {
    path: '/ice-fishing/eskimo-hc40-power-ice-auger-8-inch',
    element: <EskimoHC40AugerReviewPage />,
  },
  {
    path: '/ice-fishing/strike-master-mora-2-piece-hand-ice-auger',
    element: <StrikeMasterMoraHandAugerPage />,
  },
  {
    path: '/ice-fishing/frabill-ice-fishing-tip-up',
    element: <FrabillTipUpReviewPage />,
  },
  {
    path: '/ice-fishing/eskimo-portable-shelter',
    element: <EskimoPortableShelterReviewPage />,
  },
  {
    path: '/fly-fishing',
    element: <FlyFishingPage />,
  },
  {
    path: '/fly-fishing/moonshine-rod-co-fly-fishing-rod',
    element: <MoonshineRodReviewPage />,
  },
  {
    path: '/fly-fishing/lamson-liquid-s-series-hd-fly-fishing-reel',
    element: <LamsonLiquidReelReviewPage />,
  },
  {
    path: '/fly-fishing/piscifun-sword-fly-fishing-line',
    element: <PiscifunSwordFlyLineReviewPage />,
  },
  {
    path: '/fly-fishing/roxstar-trophy-trout-fly-assortment',
    element: <RoxStarTrophyTroutReviewPage />,
  },
  {
    path: '/fly-fishing/frogg-toggs-hellbender-breathable-waterproof-chest-wader',
    element: <FroggToggsHellbenderReviewPage />,
  },
  {
    path: '/fly-fishing/redington-fly-fishing-rod-reel-complete-starter-kit',
    element: <RedingtonStarterKitReviewPage />,
  },
  {
    path: '/fly-fishing/orvis-encounter-fly-fishing-rod-reel-combo',
    element: <OrvisEncounterReviewPage />,
  },
  {
    path: '/fly-fishing/qualyqualy-fly-fishing-chest-pack',
    element: <QualyQualyChestPackReviewPage />,
  },
  {
    path: '/fly-fishing/ventures-fly-co-122-premium-hand-tied-fly-fishing-flies-assortment',
    element: <VenturesFlyCoPage />,
  },
  {
    path: '/fly-fishing/sf-fly-fishing-line',
    element: <SFFlyFishingLinePage />,
  },
  {
    path: '/fly-fishing/piscifun-sword-fly-fishing-reel',
    element: <PiscifunSwordFlyFishingReelPage />,
  },
  {
    path: '/fly-fishing/maxcatch-ultralite-x-fly-fishing-rod',
    element: <MaxcatchUltraliteXPage />,
  },
  {
    path: '/tackle-accessories',
    element: <TackleAccessoriesPage />,
  },
  {
    path: '/tackle-accessories/plano-guide-series-stowaway-4-rack-tackle-box',
    element: <PlanoGuideSeriesReviewPage />,
  },
  {
    path: '/tackle-accessories/kastking-speed-demon-pro-fillet-knife',
    element: <KastKingSpeedDemonProFilletKnifePage />,
  },
  {
    path: '/tackle-accessories/piscifun-fishing-line-spooler',
    element: <PiscifunFishingLineSpoolerReviewPage />,
  },
  {
    path: '/tackle-accessories/gamakatsu-red-octopus-hook-100-pack',
    element: <GamakatsuRedOctopusHookPage />,
  },
  {
    path: '/tackle-accessories/kastking-karryall-fishing-tackle-backpack-with-rod-holder',
    element: <KastKingKarryAllBackpackPage />,
  },
  {
    path: '/tackle-accessories/reaction-tackle-carolina-rigs-for-bass-fishing-6-pack',
    element: <ReactionTackleCarolinaRigsPage />,
  },
  {
    path: '/tackle-accessories/kastking-hyperseal-waterproof-tackle-box-2-pack',
    element: <KastKingHyperSealTackleBoxPage />,
  },
  {
    path: '/tackle-accessories/kanama-luminous-live-shrimp-hooks',
    element: <KanamaLuminousShrimHooksReviewPage />,
  },
  {
    path: '/tackle-accessories/hoshanho-7-inch-fillet-knife',
    element: <HoshanhoFilletKnifePage />,
  },
  {
    path: '/tackle-accessories/baitium-fishing-tackle-bag-with-rod-holders',
    element: <BaitiumFishingTackleBagPage />,
  },
  {
    path: '/tackle-accessories/kastking-baitspace-line-management-bag',
    element: <KastKingBaitSpaceLineManagementBagPage />,
  },
  {
    path: '/tackle-accessories/deep-drop-snapper-rig',
    element: <TackleAccessoriesDeepDropSnapperRig />,
  },
  {
    path: '/tackle-accessories/drfish-10-carolina-ready-rigs-15-pack',
    element: <TackleAccessoriesDrfishCarolinaRigsPage />,
  },
  {
    path: '/tackle-accessories/16-inch-20lbs-fluorocarbon-fishing-leader-line-with-swivels-snap-kits',
    element: <TackleAccessories16InchFluorocarbonLeaderLinePage />,
  },
  {
    path: '/tackle-accessories/20-inch-50lb-100-fluorocarbon-fishing-leaders',
    element: <FluorocarbonLeadersPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/sitemap',
    element: <SitemapPage />,
  },
  {
    path: '/affiliate-disclosure',
    element: <AffiliateDisclosurePage />,
  },
  {
    path: '/lures-baits/berkley-flicker-shad-freshwater-crankbait',
    element: <BerkleyFlickerShadPage />,
  },
  {
    path: '/lures-baits/bandit-lures-slender-minnow-jerkbait',
    element: <BanditLuresJerkbaitReviewPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;